<template>
  <div>
    <el-row class="container">
      <el-col :span="24" class="header">
        <el-col :span="10"
                class="logo"
                :class="collapsed ? 'logo-collapse-width' : 'logo-width'">
          {{ collapsed ? '' : sysName }}
          <img src="../assets/user.jpg" class="logo-image" v-if="collapsed"/>
        </el-col>

        <el-col
          :span="1" style="text-align: left"  class="icon-menu"
          :class="collapsed ? 'collapsed' : ''"
        >
        <img src="../assets/catalog.png"
               class="catalog"
                @click="collapsed = !collapsed"
               />
        </el-col>
        <el-col class="home-link" :span="1" style="text-align: left">
          <a href="/" style="color: #fff; text-decoration: none">{{ $t('text.home') }}</a>
        </el-col>

        <el-col :span="8" class="user-info">
          <div class="content"  style="display: flex; justify-content: flex-end">
            <CountryTimeClock />
            <div class="merchantState">
              {{ $t('text.merchantStatus') }}：
              {{
                $store.state.prodStatus === '00'
                    ? $t('message.testingIntegration')
                    : ''
              }}
              {{ $store.state.prodStatus === '01' ? $t('productionStatus.01') : '' }}
              {{ $store.state.prodStatus === '02' ? $t('productionStatus.02') : '' }}
              <el-button
                  class="apply-button"
                  style="margin-left: 16px"
                  v-if="$store.state.prodStatus === '00'"
                  size="mini"
                  type="warning"
                  @click="handleOnLine"
                  :loading="merchantLoading">
                {{ $t('text.applyForLaunch') }}
              </el-button>
            </div>
            <el-dropdown trigger="hover">
              <span class="el-dropdown-link user-info-inner">
                <span class="username"> {{ $store.state.userName }}</span>
                <img src="../assets/user.jpg"/>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="updatePassword">
                  {{ $t('text.changePassword') }}
                </el-dropdown-item>
                <el-dropdown-item v-if="ROLE_TYPE.isManager()" @click.native="updateContactDialog">
                  {{ $t('text.changeContactDetails') }}
                </el-dropdown-item>
                <el-dropdown-item
                    v-if="this.contactPerson && (this.contactPerson.startsWith('http://') || this.contactPerson.startsWith('https://'))"
                    @click.native="contact">
                  {{ $t('text.contactUs') }}
                </el-dropdown-item>
                <el-dropdown-item divided @click.native="logout">
                  {{ $t('text.logout') }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-col>


      </el-col>
      <!--</el-row>-->

      <!--<el-row>-->
      <el-col :span="24" class="main">
        <aside class="menuAside">
          <!--导航菜单-->
          <el-menu :default-active="$route.path"
                   class="el-menu-vertical"
                   background-color="#FFFFFF"
                   text-color="#59607C"
                   active-text-color="#4C88F5"
                   router
                   :collapse="collapsed">
            <template v-for="(item, index) in $store.state.routes" v-if="!item.isLocked">
              <el-submenu :index="index + ''" v-if="item.subList.length >= 1">
                <template slot="title">
                  <i :class="`${item.icon} icon-${item.id}`"></i><span slot="title">{{ getMenuItemDisplayName(item.id) }}</span>
                </template>
                <el-menu-item
                    v-for="child in item.subList"
                    :index="child.url"
                    :key="child.url"
                    v-if="!child.isLocked"
                    :class="`menu-item-${child.id}`"
                    >
                  {{ getMenuItemDisplayName(child.id) }}
                </el-menu-item>
              </el-submenu>

              <el-menu-item v-if="item.subList.length === 0" :index="item.url">
                <i :class="item.icon"></i>{{ getMenuItemDisplayName(item.id) }}
              </el-menu-item>
            </template>
          </el-menu>
        </aside>

        <section class="content-container">
          <tags-view v-if="needTagsView"/>
          <el-col :span="24" class="content-wrapper">
            <Breadcrumb />
            <transition name="fade" mode="out-in">
              <keep-alive>
                <router-view></router-view>
              </keep-alive>
            </transition>
          </el-col>
        </section>
      </el-col>
    </el-row>

    <UpdatePassword :show.sync="showUpdatePasswordDialog"></UpdatePassword>
    <SetPayPassword :show.sync="showSetPayPasswordDialog"></SetPayPassword>
    <UpdatePayPassword :show.sync="showUpdatePayPasswordDialog"></UpdatePayPassword>
    <BindAuthCode :show.sync="showBindAuthCodeDialog"></BindAuthCode>
    <UpdateContact :show.sync="showUpdateContactDialog" :originalContact="contactPerson"></UpdateContact>
  </div>
</template>

<script>
import UpdatePassword from '@/components/UpdatePassword.vue'
import UpdateContact from '@/components/UpdateContact.vue'
import SetPayPassword from '@/components/SetPayPassword.vue'
import UpdatePayPassword from '@/components/UpdatePayPassword.vue'
import BindAuthCode from '@/components/BindAuthCode.vue'
import Constant, {ROLE_TYPE} from '../utils/Constant'
import TagsView from '@/components/TagsView'
import Breadcrumb from '@/components/Breadcrumb'
import CountryTimeClock from '@/components/CountryTimeClock.vue'

export default {
  data() {
    return {
      sysName: this.$t('text.adminConsole'),
      collapsed: false,
      Constant: Constant,
      showUpdatePasswordDialog: false,
      showSetPayPasswordDialog: false,
      showUpdatePayPasswordDialog: false,
      showBindAuthCodeDialog: false,
      showUpdateContactDialog: false,
      merchantLoading: false,
      keepAlive: true,
      contactPerson: '',
    }
  },

  components: {
    UpdatePassword: UpdatePassword,
    SetPayPassword: SetPayPassword,
    UpdatePayPassword: UpdatePayPassword,
    BindAuthCode: BindAuthCode,
    UpdateContact: UpdateContact,
    TagsView: TagsView,
    Breadcrumb,
    CountryTimeClock,
  },
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE
    },
    needTagsView() {
      return this.$store.state.tagsView
    }
  },
  methods: {
    //退出登录
    logout() {
      this.$confirm(this.$t('message.confirmSigningOut'), this.$t('text.prompt'), {
        confirmButtonText: this.$t('text.confirm'),
        cancelButtonText: this.$t('text.cancel'),
        type: 'warning',
      })
          .then(() => {
            this.axios
                .post('/sysUserInfo/exit', {
                  sysId: this.$store.state.sysId,
                })
                .then(res => {
                  if (res.code === 200) {
                    this.$store.commit('setIsLogin', false)
                    this.$store.commit('setUserId', null)
                    this.$store.commit('setUserName', null)
                    this.$store.commit('setRoutes', [])
                    this.$router.push('/login')
                    this.$store.dispatch('delAllViews', null, {
                      root: true,
                    })
                  }
                })
          })
          .catch(() => {
          })
    },
    updatePassword() {
      this.showUpdatePasswordDialog = true
    },
    updatePayPassword() {
      this.showUpdatePayPasswordDialog = true
    },
    bindAuthCode() {
      this.showBindAuthCodeDialog = true
    },
    contact() {
      if (this.contactPerson.startsWith("http://") || this.contactPerson.startsWith("https://")) {
        window.open(this.contactPerson, "_blank");
      }
    },
    updateContactDialog() {
      this.showUpdateContactDialog = true
    },
    handleOnLine() {
      this.$confirm(this.$t('message.confirmApplyingProduction'), this.$t('text.prompt'), {
        confirmButtonText: this.$t('text.confirm'),
        cancelButtonText: this.$t('text.cancel'),
        type: 'warning',
      })
          .then(() => {
            this.merchantLoading = true
            this.axios.get('/merchant/applyProd', {params: {}}).then(res => {
              this.merchantLoading = false
              if (res.code === 200) {
                this.$store.commit('setProdStatus', '01')
                sessionStorage.setItem('store', JSON.stringify(this.$store.state))
                this.$notify({
                  title: this.$t('text.prompt'),
                  message: res.msg,
                  type: 'success',
                })
              }
            })
          })
          .catch(() => {
            this.merchantLoading = false
          })
    },
    getMenuItemDisplayName(id) {
      return this.$t("menu." + id + ".displayName");
    }
  },
  created() {
    let url = ''

    if (
        this.$store.state.roleId === Constant.MER_ROLE_WITH_NO_DEVICE ||
        this.$store.state.roleId === Constant.MER_ROLE_WITH_DEVICE
    ) {
      url = '/merchant/isSetPayPassword'
    }
    if (
        this.$store.state.roleId === Constant.FIRST_AGENT_ROLE_WITH_DEVICE ||
        this.$store.state.roleId === Constant.FIRST_AGENT_ROLE_WITH_NO_DEVICE ||
        this.$store.state.roleId === Constant.SECOND_AGENT_ROLE_WITH_DEVICE ||
        this.$store.state.roleId === Constant.SECOND_AGENT_ROLE_WITH_NO_DEVICE
    ) {
      url = '/merchant/isSetPayPasswordForAgent'
    }

    const configName = 'CONSTANT_CONFIG';
    this.$axios.get("/config/select", {params: {configName}}).then(res => {
      const jsonObject = JSON.parse(res.data);
      this.contactPerson = jsonObject.contact;
    })
  }
}
</script>

<style scoped lang="scss">

.merchantState {
  display: flex;
  align-items: center;
  margin-right: 30px;
  font-size: 13px;
  color: #e6a23c;
}

.menuAside {
  height: calc(100vh - 60px);
  overflow-y: scroll;

  &::-webkit-scrollbar {
    // chrome safari
    display: none;
  }
}

.el-menu-vertical {
  color: white;
  text-align: left;
  border: none !important;
  height: 100%;
}



.catalog {
  width: 26px;
  height: 26px;
  margin-top: 17px;

}


.logo-image {
  width: 40px;
  height: 40px;
  padding-top: 10px;
  padding-left: 10px;
}

.my-message {
  margin-right: 10px;
  height: 25px;
}

.container {
  width: 100vw;
  height: 100vh;
  min-width: 1030px;

  .header {
    height: 60px;
    line-height: 60px;
    color: #ffffff;
    background-color: #3f4457;

    .user-info {
      text-align: right;
      padding-right: 15px;
      width: 70%;

      float: right;

      .user-info-inner {
        cursor: pointer;
        color: #ffffff;

        img {
          width: 40px;
          height: 40px;
          border-radius: 20px;
          margin: 10px 0 10px 10px;
          float: right;
        }
      }
    }

    .logo-width {
      width: 230px;
      font-size: 22px;
      padding-left: 20px;
      padding-right: 20px;

      img {
        width: 40px;
        float: left;
        margin: 10px 10px 10px 18px;
      }

      .txt {
        color: #fff;
      }
    }

    .logo-collapse-width {
      width: 64px;
    }

    .tools {
      padding: 0 23px;
      width: 14px;
      height: 60px;
      line-height: 60px;
      cursor: pointer;
    }
  }

  .main {
    display: flex;
    bottom: 0;
    overflow: hidden;

    .content-container {
      flex: 1;
      background-color: #f0f2f7;
      margin-right: 0;
      min-width: 800px;

      .breadcrumb-container {
        width: 100%;
        height: 50px;
        background-color: #f0f2f7;
        text-align: left;
        border-bottom: 1px #d1d9e2 dashed;
        line-height: 50px;

        .title {
          /*width: 100%;*/
          float: left;
          color: black;
          margin-left: 10px;
        }

        .breadcrumb-inner {
          float: right;
        }
      }

      .content-wrapper {
        height: calc(100vh - 95px);
        /*background: url(../assets/dashed.png) repeat-x left top;*/
        text-align: left;
        overflow: auto;
      }
    }
  }
}
</style>
